// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"209":"worldcup","547":"missions","813":"mission"}[chunkId] + "." + {"209":"314f98e2","547":"071e6d3e","813":"1c30be92"}[chunkId] + ".js";
};